import { connect } from 'react-redux';
import Registrations from "../../../../components/admin/riaContacts/acordionSections/Registrations";

const mapStateToProps = (state) => {
  return {
    adminUserSession: state.adminLogin.adminUserSession,
  }
}

const RegistrationsContainer = connect(mapStateToProps, {})(Registrations)

export default RegistrationsContainer;